/* OVRDRV: pass website form submissions to Klaviyo. No Klaviyo app embed, no tracking script, no cookies.
   rev 7 (30 Sep): subscription payload fixed (Klaviyo rejected the consent field in rev 6).
   - Enquiry forms (have contact[Form]) -> event 'OVRDRV Stockist Enquiry' / 'OVRDRV General Enquiry' (R4/R5).
   - Ticked marketing box on an enquiry form, or the updates sign-up (customer form, tags incl. 'newsletter')
     -> subscribe to OVRDRV Updates (RWSaLi). DOUBLE OPT-IN: Klaviyo sends a confirmation email first; R6
     Welcome only after they confirm.
   - Held in sessionStorage at submit; sent on the page Shopify shows after accepting the form. */
(function () {
  var CO = 'TKM3Pf';
  var HDR = { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' };
  var KEY = 'ovrdrv_kl_pending';
  var UPDATES_LIST = 'RWSaLi';
  function val(form, name) {
    var el = form.elements[name];
    if (!el) return '';
    if (el.type === 'checkbox') return el.checked ? (el.value || 'Yes') : '';
    return typeof el.value === 'string' ? el.value.trim() : '';
  }
  function okEmail(e) { return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(e); }
  function subscription(email, source) {
    return { data: { type: 'subscription', attributes: { custom_source: source, profile: { data: { type: 'profile', attributes: { email: email } } } }, relationships: { list: { data: { type: 'list', id: UPDATES_LIST } } } } };
  }
  function enquiry(form, email) {
    var formLabel = val(form, 'contact[Form]');
    var metric = /stockist/i.test(formLabel) ? 'OVRDRV Stockist Enquiry' : 'OVRDRV General Enquiry';
    var parts = val(form, 'contact[name]').split(/\s+/);
    var first = parts.shift() || '';
    var last = parts.join(' ');
    var props = { form: formLabel, page: location.pathname };
    ['Business name', 'Business type', 'Enquiry type', 'Location', 'Country', 'Product', 'Part number'].forEach(function (k) {
      var v = val(form, 'contact[' + k + ']');
      if (v) props[k.toLowerCase().replace(/\s+/g, '_')] = v;
    });
    var profile = { email: email };
    if (first) profile.first_name = first;
    if (last) profile.last_name = last;
    if (props.business_name) profile.organization = props.business_name;
    return { data: { type: 'event', attributes: { properties: props, metric: { data: { type: 'metric', attributes: { name: metric } } }, profile: { data: { type: 'profile', attributes: profile } }, unique_id: email + '|' + Date.now() } } };
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.elements || !form.elements['contact[email]']) return;
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    var email = val(form, 'contact[email]');
    if (!okEmail(email)) return;
    var jobs = [];
    if (form.elements['contact[Form]']) {
      jobs.push({ url: 'https://a.klaviyo.com/client/events/?company_id=' + CO, body: enquiry(form, email) });
      if (val(form, 'contact[Marketing consent]')) jobs.push({ url: 'https://a.klaviyo.com/client/subscriptions/?company_id=' + CO, body: subscription(email, 'Website enquiry form: ' + val(form, 'contact[Form]')) });
    } else if (/newsletter/i.test(val(form, 'contact[tags]'))) {
      jobs.push({ url: 'https://a.klaviyo.com/client/subscriptions/?company_id=' + CO, body: subscription(email, 'Website updates sign-up') });
    }
    if (!jobs.length) return;
    try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), jobs: jobs })); } catch (err) {}
  }, true);
  function flush() {
    var posted = /[?&](contact|customer)_posted=true/.test(location.search) || !!document.querySelector('.fmsg--ok');
    if (!posted || !window.fetch) return;
    var raw = null;
    try { raw = sessionStorage.getItem(KEY); sessionStorage.removeItem(KEY); } catch (err) {}
    if (!raw) return;
    var item;
    try { item = JSON.parse(raw); } catch (err) { return; }
    if (!item || !item.jobs || Date.now() - item.t > 30 * 60 * 1000) return;
    item.jobs.forEach(function (j) { fetch(j.url, { method: 'POST', headers: HDR, body: JSON.stringify(j.body) }).catch(function () {}); });
  }
  if (document.readyState !== 'loading') flush(); else document.addEventListener('DOMContentLoaded', flush);
})();
